export const downloadFile = (content: string, filename: string, contentType: string = 'application/json'): void => {
    const blob = new Blob([content], { type: contentType });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
};

export const getFilenameFromS3Url = (s3Url: string): string => {
    const parts = s3Url.split('/');
    const lastPart = parts[parts.length - 1];
    return lastPart;
};